export default "__VITE_ASSET__Lq37j6YU__"